import React,{useState,useEffect} from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,
    HopIcon,
    Pencil,
    Trash2,
    Recycle,
    ChevronUp,
    ChevronDown,
    Film,
    GripHorizontal,
    ChevronRight,
    ScrollText,
    LaptopMinimal,
    GalleryVerticalEnd,
    FileSpreadsheet,
    Baby,
    Cat,
    Rocket,
    SquareSplitHorizontal,
    RectangleHorizontal,
    Eye} from 'lucide-react';

import SectionsQuizAddMore from "./SectionsQuizAddMore";
import CreateSectionPopUp from "./CreateSectionPopUp";
import { createNewQuestion,createNewMockSection,getSectionsByQuizId, getQuestionsByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import Toggle from "../../../UI/Toggle";
import Snackbar from "../../../../Snackbar";
import SectionsQuizAddMoreLoading from "./SectionsQuizAddMoreLoading";
import TestDesignSettings from "./TestDesignSettings";
import CreateNewQuestionPopUp from "./CreateNewQuestionPopUp";
import ListUISettings from "../../CreateApp/DesignElements/ListUISettings";
import QuestionCardLoading from "./QuestionCardLoading";
import RangeSliderBasic from "../../../UI/RangeSliderBasic";
import QuestionOptions from "./QuestionOptions";
import SetSectionForQuestion from "./SetSectionForQuestion";
import MockTest from "./TestInterface/MockTest";
import SetTopicSidebar from "./SetTopicSidebar";
import RichTextCardPopUp from "./RichTextCardPopUp";
import QuestionInstructions from "./QuestionInstructions";
import QuestionRichContent from "./QuestionRichContent";

  
const QuestionDashboard= ({setShowQuestionsPopUp,parentID,quizObject,})=>{ 
    const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
   const [currentIndex, setCurrentIndex] =useState(1);
   const [goNextPopUp, setGoNextPopUp] =useState(false);
    const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
           
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
    
     const [loader , setLoader] =useState({status:false});
     const [animate, setAnimate] = useState(false);
    
         const [deleteQuestionPopUp, setDeleteQuestionPopUp] = useState(false);
         const [deleteId, setDeleteId] = useState("");
            const [isLockSections, setIsLockSections] = useState();
      const [createNewQuestionPopUp, setCreateNewQuestionPopUp] = useState(false);
     const [currentQuestionObject, setCurrentQuestionObject] = useState("");
      const [hideSectionPopUp, setHideSectionPopUp] = useState(false);
      const [reloadQuestions, setReloadQuestions] = useState(true);
    // let allSections= allSectionsData
const [parentFolder, setParentFolder] = useState({ID:""});
    
    const [showTestPreview, setShowTestPreview] = useState(false);
        const [allSections, setAllSections] = useState([]);
       
        const [ visibility, setVisibility] = useState("public");
        const [ showLeftQueBar, setShowLeftQueBar] = useState(true);
        const [ queTypePopUp, setQueTypePopUp] = useState(false);
        const [ difficultyLevel, setDifficultyLevel] = useState("");
        const [ marks, setMarks] = useState(0);
        const [ negativeMarks, setNegativeMarks] = useState(0);
        const [ divideColumn, setDivideColumn] = useState("");
        const [ enableDisplayMarks, setEnableDisplayMarks] = useState(false);
       const [ enableQueHint, setEnableQueHint] = useState(false);
       const [ showHintPopUp, setShowHintPupUp] = useState(false);
       const [ hintInfo, setHintInfo] = useState("");
       const [ responseTime, setResponseTime] = useState(1);
       const [ showQuestionOptions, setShowQuestionOptions] = useState(true);
       const [ reloadItems, setReloadItems] = useState(true);
          
 const [itemArr, setItemArr] = useState(allSections);
 const [itemArrDummy, setItemArrDummy] = useState(allSections);
 const [currentSection, setCurrentSection] = useState("All Sections");
const [explanationPopUp, setExplanationPopUp] = useState(false);
const [instructionPopUp, setInstructionPopUp] = useState(false);
 
 
       const [ closeTopicSidebar, setCloseTopicSidebar] = useState(false);
  const [sectionsArr, setSectionsArr] = useState([]);
   let newSection= { no:1, id: generateTimestamp()
          ,title:"" ,sectionName:"",lockTime:10,questions:[] } ;
     useEffect(() => {
        
        
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
    
      useEffect(()=>{
      
        fireGetQuestionsByQuizId()
        fireGetSectionDataByQuizId();
      },[])
   


      const handleBack=(e)=>{
  
        setLoader({status:true});
        
        history.goBack();
        }
        
 
    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.ID !== id);
        setItemArr(filteredItems);
        handleCreateNewQuestion("deleteItem","",id)
      };
      const updateItemtitle = (id, sectionName,questionId) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, sectionName :sectionName } : item
        
        ); 
        
        setItemArr(updatedItems);
        handleCreateNewQuestion("sectionName",sectionName,questionId)
       
      };
      const updateItemlockTime = (id, lockTime,questionId) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, lockTime :lockTime } : item
        
        ); 
        
        setItemArr(updatedItems);
      
       handleCreateNewQuestion("lockTime",lockTime,questionId)
      };
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';

const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
useEffect(()=>{
  setShowQuestionOptions(false);setTimeout(()=>{ setShowQuestionOptions(true);},10)
},[currentQuestionObject?.ID])
const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    ID: item.ID,
  }));
  setItemArr(reorderedItems);
  handleCreateNewQuestion("updateSections",reorderedItems);
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   const fireGetQuestionsByQuizId=()=>{
   setItemArrLoading([{},{},{},{},{},{}])
    setLoader({status:true});
    
      const apiData = dispatch(getQuestionsByQuizId({testName:"",type:"question",
        postParent:quizObject?.ID,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:"",menuOrder:flattenedData?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
            // console.log(response)
          if(response?.questions){
            setCurrentSection("All Sections");

            setItemArrLoading([])
            setCurrentQuestionObject(response?.questions.length?response?.questions[0]:"")
        setResponseMessage(response?.message);  
        setSnackbarColor("rgba(144, 202, 249,1)");
      
         setItemArr( response?.questions?response?.questions:[])
         setItemArrDummy( response?.questions?response?.questions:[])
          setResponseTime(0)
       setTimeout(()=>{setResponseTime(1)},10) 

       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
  const fireGetSectionDataByQuizId=()=>{
   setItemArrLoading([{},{},{},{}])
    setLoader({status:true});
    
      const apiData = dispatch(getSectionsByQuizId({testName:"",type:"section",
        postParent:quizObject?.ID,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
            // console.log(response)
          if(response?.sections){
            setItemArrLoading([])
        setResponseMessage(response?.message);  
        setSnackbarColor("rgba(144, 202, 249,1)");
      
         setSectionsArr( response?.sections?response?.sections:[])
        //  setQuestionArr(response?.sections?.secQuestions?response?.sections.secQuestions:[])

       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }

  const handleCreateNewQuestion=(editType,val,questionId)=>{
     let SendObject=""
     if(editType=="queType"){
        SendObject={queType:val,type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             if(editType=="queName"){
        SendObject={queName:val,type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             if(editType=="difficultyLevel"){
        SendObject={difficultyLevel:val,type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
            if(editType=="marks"){
        SendObject={marks:val,type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
              if(editType=="negativeMarks"){
        SendObject={negativeMarks:val,type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             if(editType=="divideColumn"){
        SendObject={divideColumn:(val),type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }  if(editType=="enableDisplayMarks"){
        SendObject={enableDisplayMarks:JSON.stringify(val),type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
              if(editType=="enableQueHint"){
        SendObject={enableQueHint:(val),type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }  if(editType=="hintInfo"){
        SendObject={hintInfo:(val),type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
              if(editType=="responseTime"){
        SendObject={responseTime:val,type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
              if(editType=="deleteItem"){
        SendObject={type:"question",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:questionId?editType:"",postId:questionId?questionId:"",menuOrder:itemArrDummy?.length+1,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
            
         
            //   console.log(SendObject)
            
                                                                             
     setLoader({status:true});
     
       const apiData = dispatch(createNewQuestion(SendObject));


       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
          
           if(response?.question){
    //         //  if(questionId==response?.question?.ID){}else{
    // setCreateNewQuestionPopUp(false);
    // }
    
            if(editType=='queName'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ?response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question); 
setHideSectionPopUp(true);;emptyCurrentItemStates();
   }else{setItemArr([...itemArr,response?.question]);
    setItemArrDummy([...itemArr,response?.question]);
    setCurrentQuestionObject(response?.question);emptyCurrentItemStates();
    
   }
            } 
            
            if(editType=='queType'){
   if(questionId==response?.question?.ID){
     const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ? response?.question : item
        
        ); 
        
setItemArr(updatedItems);
setItemArrDummy(updatedItems);
setCurrentQuestionObject(setCurrentQuestionObject(response?.question))
   }else{ setItemArr([...itemArr,response?.question]); setItemArrDummy([...itemArr,response?.question]);
    setCurrentQuestionObject(response?.question); emptyCurrentItemStates();
    setCreateNewQuestionPopUp(true);}
            }

           if(editType=='difficultyLevel'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ? response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question) ;
   }else{setItemArr([...itemArr,response?.question]);setCurrentQuestionObject(response?.question);emptyCurrentItemStates();}
            } 

            if(editType=='marks'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ?response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question) ;
   }else{setItemArr([...itemArr,response?.question]);setCurrentQuestionObject(response?.question);emptyCurrentItemStates();}
            }
            if(editType=='negativeMarks'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ? response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question) ;
   }else{setItemArr([...itemArr,response?.question]);setCurrentQuestionObject(response?.question);emptyCurrentItemStates();}
            } 
            
            if(editType=='divideColumn'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ? response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question)
   }else{setItemArr([...itemArr,response?.question]);setCurrentQuestionObject(response?.question);emptyCurrentItemStates();}
            } 
            
             if(editType=='enableDisplayMarks'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ? response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question) ;
   }else{setItemArr([...itemArr,response?.question]);setCurrentQuestionObject(response?.question);emptyCurrentItemStates();}
            } 
            
             if(editType=='enableQueHint'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ? response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question)
   }else{setItemArr([...itemArr,response?.question]);setCurrentQuestionObject(response?.question);emptyCurrentItemStates();}
            } 

              if(editType=='hintInfo'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ? response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question)
   }else{setItemArr([...itemArr,response?.question]);setCurrentQuestionObject(response?.question);emptyCurrentItemStates();}
            } 
           
             if(editType=='responseTime'){
   if(questionId==response?.question?.ID){
    const updatedItems = itemArr.map(item =>
          item.ID === response?.question?.ID ? response?.question : item
        
        ); 
setItemArr(updatedItems);setItemArrDummy(updatedItems);
setCurrentQuestionObject(response?.question) ;
   }else{setItemArr([...itemArr,response?.question]);setCurrentQuestionObject(response?.question);emptyCurrentItemStates();}
            } 
            
     setLoader({status:false});
     
     setTimeout(()=>{
       
       setSnackbarVisible(false);
     
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }

      const emptyCurrentItemStates=()=>{
        setDifficultyLevel("");
        setDivideColumn("");
        setMarks(0);  setNegativeMarks(0);
        setEnableDisplayMarks("")
        setEnableQueHint("");
        setHintInfo("");;
        setResponseTime(0)
         setReloadItems(false);
           setTimeout(()=>{
        setReloadItems(true);
       },10) 
       setTimeout(()=>{setResponseTime(1);
        
       },10) 


      }
      function toBoolean(str) {
  return str === "true";
}

// console.log(toBoolean("true"));
const findSectionNameByQuestionId = (questionId) => {
  for (const section of sectionsArr) {
    try {
      const secQuestions = typeof section?.secQuestions === "string"
        ? JSON.parse(section?.secQuestions)
        : section?.secQuestions || [];

      const found = secQuestions?.some(q => q?.ID?.toString() === questionId?.toString());
      
      if (found) {
        return section?.sectionName;
      }
    } catch (error) {
      console.error("Invalid JSON in secQuestions for section ID:", section?.ID, error);
    }
  }

  return null;
};
const getQuestionsFromOneSection = ( secQuestionsRaw) => {
  let secQuestions = [];

  try {
    secQuestions = Array.isArray(secQuestionsRaw)
      ? secQuestionsRaw
      : JSON.parse(secQuestionsRaw || '[]');
  } catch (e) {
    console.warn("Invalid JSON in secQuestions", e);
  }

  const questionIDs = new Set(secQuestions.map(q => q?.ID));
  return itemArrDummy?.length?itemArrDummy?.filter(item => questionIDs?.has(item?.ID)):false;
};

const getArrayLength =(section)=>{
  return section?.secQuestions?JSON.parse(section?.secQuestions).length:0
}
     return(<>
              {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 
   <div   className="AreYouSurePopUpFive" style={{borderRadius: '0px',border:"0px solid #fff",background:"rgb(244, 253, 255)"}}>
              <div style={{}}>
              


     

 <div   className={!showLeftQueBar? "":"QuestionDashboardPopUpRight"} style={{borderRadius: '0px',border:"0px solid #fff",background:"rgb(244, 253, 255)"}}>
   {createNewQuestionPopUp?<CreateNewQuestionPopUp  setInstructionPopUp={()=>{setInstructionPopUp(true)}}  currentQuestionObject={currentQuestionObject}  sendBackData={(data)=>{   handleCreateNewQuestion("queName",data,currentQuestionObject?.ID?currentQuestionObject?.ID:"")}} closeSectionPopUp={()=>{ setCreateNewQuestionPopUp(false);}} /> :""}
 
 {explanationPopUp?<> <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:9999999999,cursor:"pointer"}} onClick={()=>{}} className="appDesignPopUpOpacity"> </div>
  
    <div  className="AreYouSurePopUpFour"style={{margin:"0px",zIndex:99999999999,border:"0px solid #ffffff",borderRadius:"25px"}}>
      <RichTextCardPopUp contentType="explaination" cardTitle="Add Question " cardTitleColor="Explaination"
 setRichTextPopUp={()=>{setExplanationPopUp(false)}} postParentId={currentQuestionObject?.ID}/></div> </>:""}
{instructionPopUp?<> <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:9999999999,cursor:"pointer"}} onClick={()=>{}} className="appDesignPopUpOpacity"> </div>
  
    <div  className="AreYouSurePopUpFour"style={{margin:"0px",zIndex:99999999999,border:"0px solid #ffffff",borderRadius:"25px"}}>
      <RichTextCardPopUp setRichTextPopUp={()=>{setInstructionPopUp(false)}} 
 contentType="instruction" cardTitle="Add Question " cardTitleColor="Instructions"
  postParentId={currentQuestionObject?.ID} /></div> </>:""}
 
 
   
   
    {showLeftQueBar? <div   className="QuestionDashboardPopUpLeft " style={{borderRadius: '0px',border:"0px solid #fff",background:"rgb(244, 253, 255)"}}> 
   
    
  {queTypePopUp?<div>
    <div   onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer",opacity:"0.2",background:"#000"}}  className="appDesignPopUpOpacity"> </div>
         <div   className="AreYouSurePopUp" style={{height:"200px",borderRadius: '20px'}}> 
         <h1 align="center" >   Select Question Type </h1>
       
  
 <div className="bookmarkListScroll" style={{overflowY:"auto",height:"180px",overflowX:"hidden"}}>
 
     <div className="">
     
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{ handleCreateNewQuestion("queType","MCQ","");setQueTypePopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> MCQ </button>
 
 
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{ handleCreateNewQuestion("queType","MSQ","");setQueTypePopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> MSQ </button>
 
 
 
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{ handleCreateNewQuestion("queType","NAT","");setQueTypePopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> NAT </button>
 
 
 
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{ handleCreateNewQuestion("queType","True-False","");setQueTypePopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> True-False </button>
 
 
 
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{ handleCreateNewQuestion("queType","Essay","");setQueTypePopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> Essay </button>
 
 
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{ handleCreateNewQuestion("queType","Drag Matching","");setQueTypePopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> Drag Matching </button>
 
 
 
 </div>
 
 </div>
 
      </div>
 </div>:""}
 
  {deleteQuestionPopUp?<div>
    <div   onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer",opacity:"0.2",background:"#000"}} onClick={()=>setDeleteQuestionPopUp(false)} className="appDesignPopUpOpacity"> </div>
         <div   className="AreYouSurePopUp" style={{height:"200px",borderRadius: '20px'}}> 
         <h1 align="center" >   Are You Sure? </h1>
       
  
 <div className="bookmarkListScroll" style={{overflowY:"auto",height:"180px",overflowX:"hidden"}}>
 
     <div className="">
     
 
 
 
 
 
 </div>
 
 <div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
    
    transition: 'transform 2s ease, opacity 1s ease',
  }}><button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={(id)=>{setDeleteQuestionPopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> No </button>
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{removeItem(deleteId);setDeleteQuestionPopUp(false)}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"200px",cursor:"pointer",zIndex:99999,height:"55px"}} 
   className=" CoursesPreviewTopBtn"  type="submit"
  >Yes. Delete this section.</button>
 </div> 
 </div>
 
      </div>
 </div>:""}
   
   <div style={{display:"flex",justifyContent:"space-between",gap:"20px"}}> 
    <div className="sectionFilterOuter " style={{position:"absolute",zIndex:"999999",left:"50px",top:"0px",margin:"15px",display:"flex",justifyContent:"center",alignItems:"center",}}>
     
     <div  style={{width:"220px",padding:"5px",margin:"5px",background:"#f9f9f9",fontSize:"16px",fontWeight:"999",display:"flex",justifyContent:"space-around",alignItems:"center",}} 
      > <div style={{width:"50px",background:"#fff",padding:"5px",borderRadius:"15px",display:"flex",justifyContent:"center",alignItems:"center",}}>{itemArr?.length} Ques</div></div>
 
</div>
     <div style={{background:"rgba(86, 82, 131,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",right:"10px",top:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"15px",zIndex:99999,cursor:"pointer"}} onClick={()=>setShowLeftQueBar(false)} ><ChevronLeft size={22}  color="rgb(86, 82, 131)"/></div> 
</div>
               <div  className=" " style={{borderRadius:"15px",margin:"5px",marginTop:"70px",height:"90vh",overflowY:"auto",border:"5px solid #fff "}}>
  <div  className=" " >
   
  
<div  className="ikcraft_login-input-card"style={{
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease',
   }}>

  {reloadQuestions?itemArr?.length?itemArr?.map((itemQuestion, index) => 
        (
        <div  index={index} key={itemQuestion?.ID}   >
                
{selectedItemIndex!==index?
<div
            className="drop-zone"
            onDragOver={(e) => {setHoveredDropZone(index);
              handleDragOver(e, index)
            }}
            onDrop={(e) => {handleDrop(e, index);setSelectedItemIndex(null);}}
          
            style={{
              height: hoveredDropZone === index ?'95px':"0px",position:hoveredDropZone === index ?'relative':"",left:"0px",right:"0px",
              backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
              border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
              transition: 'background-color  0.3s ease',width:"95%",
              borderRadius: '10px',marginBottom:hoveredDropZone === index ?"10px":"0px"
             
            }}
          ></div>:""}
           <div

onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}

             draggable 
             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(itemQuestion?.ID); setSelectedItemIndex(index);
             }}className={draggedIndex == itemQuestion?.ID?"posFixed":"posRelative"  }
             style={{ padding:"5px",
               position:"relative",borderRadius:"10px",overflow:"hidden"}} 
          
              onDragEnd={handleDragEnd}
            ><div style={{margin:"5px",marginTop:"0px",padding:"0px",background:"#ffffff",borderRadius:"10px",overflow:"hidden",}}>
            <div style={{display:"flex",justifyContent:"space-between",gap:"20px"}}>  <div  style={{height:"19.2px",
            zIndex:"9999", top:"0px",maxWidth:"80px"}} 
          className="product-tag-theme1 TitleWithEllipsis">  <div  
          color="#666666" align="center" style={{padding:"4px",float:"left",width:"10px",height:"10px",
          background:"#ffffff",color:"#222",borderRadius:"15px",cursor:"pointer",cursor: 'move',marginRight:"10px"}}>
            {index+1}</div>{itemQuestion?.queType} </div>
        <div className="TitleWithEllipsis" style={{width:"110px",padding:"4px"}}>    {findSectionNameByQuestionId(itemQuestion?.ID)}</div>
        <div align="right" onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} onClick={()=>{setHideSectionPopUp(true);setCurrentQuestionObject(itemQuestion);setCurrentIndex(index+1);emptyCurrentItemStates();}} strokeWidth={2} absoluteStrokeWidth  size={18} 
       color="rgba(144, 202, 249,1)" style={{padding:"4px",paddingTop:"5px",background:"rgba(144, 202, 249,0.1)",height:"18px",
          fontSize:"13px",borderRadius:"5px",color:"#222"
       ,marginRight:"10px",cursor:"pointer",margin:"4px"}}>{findSectionNameByQuestionId(itemQuestion?.ID)?"Change":"Add Section"}
        </div></div>
<div  className="questionSingleCardGrid"style={{margin:"0px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:"#ffffff"}} >

          <div className="courseContentItemJustifyContentIcons">{visibility=="public"?<NotepadText  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>}
 </div>
 <div className="courseContentItemJustifyContent"> <div className="themeNone ButtonWithEllipsis "
 style={{fontSize:"15px",color:"#111",fontWeight:"700" ,}}> 
 Q{itemQuestion?.menuOrder}: {itemQuestion?.queName}
   
      </div></div>
      <div  className=""
         style={{fontSize:"10px",color:"#222",display:"flex",justifyContent:"space-around",fontWeight:"800"}}>
          <Pencil
        onClick={()=>{ setCurrentQuestionObject(itemQuestion);setCurrentIndex(index+1);emptyCurrentItemStates();setCreateNewQuestionPopUp(true);}} 
         onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"5px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
       
        {visibility=="public"?<Eye
        onClick={()=>{ setCurrentQuestionObject(itemQuestion);setCurrentIndex(index+1);emptyCurrentItemStates();}} 
         onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"5px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>:<div></div> }
                  
        {visibility=="public"?<Trash2 onClick={()=>{setDeleteQuestionPopUp(true) ; setDeleteId(itemQuestion?.ID)}}  onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> :
         <Recycle onClick={()=>{  }}  onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>}
         </div>
        
 </div> </div></div></div> )):flattenedDataLoading?.length==0?flattenedData?.length?"":<div align="center"style={{margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
}}> Opps... <span className="coloredTextV1">No Question Found !!!</span> Create Your First Question In This Section  And  Add Folders.     </h3>
<div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{}} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#222" style={{padding:"4px",paddingTop:"5px",background:"#fff"
    ,border:"2px solid #222",height:"25px",width:"100px",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,marginRight:"10px",cursor:"pointer"}}>Add 
 <span className="hidexs"> Questions</span> </div>
</div>: "":""}
   
    </div>  
    
    
     <div>
      { flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={index}    >
  
         <QuestionCardLoading/>
        
</div>)):""} </div>
    
    
     {flattenedDataLoading.length==0&&flattenedData.length==0? <div style={{fontSize:"28px",fontWeight:"bold",padding:"5px",marginTop:"45px",
                 paddingLeft:"10px",display:"flex",margin:"15px",justifyContent:"center",border:"3px solid rgba(144, 202, 249,0.41)",marginTop:"10px",background:"#ffffff",borderRadius:"15px",padding:"5px",
             display:"flex",justifyContent:"center"
            }}>
             No Question Found </div>:"" }
    
     <div align="center">
<div align="center"   style={{width:"240px",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New Question </div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{flattenedData?.length==0?setQueTypePopUp(true):setQueTypePopUp(true);setCurrentQuestionObject("");setCurrentIndex(""); emptyCurrentItemStates();  }}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
    </div>
    </div>  
   

 </div></div>:""}
        
        
        
         <div style={{background:"rgba(86, 82, 131,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",right:"10px",top:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"10px",zIndex:99999,cursor:"pointer"}} onClick={()=>setShowQuestionsPopUp()} ><X size={22}  color="rgb(86, 82, 131)"/></div> 
 {!showLeftQueBar? <div style={{background:"rgba(86, 82, 131,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",left:"0px",top:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"10px",zIndex:99999,cursor:"pointer"}} onClick={()=>setShowLeftQueBar(true)} ><ChevronRight size={22}  color="rgb(86, 82, 131)"/></div> 
:""}
<div className="questionDashboardOuterScroll" >
    <div style={{fontSize:"18px",fontWeight:"bold",padding:"10px",width:showLeftQueBar?"55vw":"65vw",marginTop:"10px",background:"#ffffff",borderRadius:"15px",
                 paddingLeft:showLeftQueBar?"10px":"70px",display:"flex",justifyContent:"space-between"}}>
                  Question {currentIndex} {"   ("+currentQuestionObject?.queType+")   "} Settings  
                   <button className="classSettBtns" style={{background:"#fff",color:"rgba(144, 202, 249,1)"}} 
                   onClick={()=>{ setShowTestPreview(true) }} > Preview</button></div> 
 <div className="gridForQuestionRightDashboard" style={{overflowY:"auto"}}>
   
        <div className="questionDashboardScroll" style={{overflowX:"hidden"}}>

 <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",margin:"10px",padding:"0px",overflow:"hidden"}}>

  <div style={{display:"flex",justifyContent:"space-between",gap:"20px"}}>  
<div  style={{height:"19.2px",
            zIndex:"9999", top:"0px",}} 
          className="product-tag-theme1">  <div  
          color="#666666" align="center" style={{padding:"4px",float:"left",width:"10px",height:"10px",
          background:"#ffffff",color:"#222",borderRadius:"15px",cursor:"pointer",cursor: 'move',marginRight:"10px"}}>{currentIndex}</div>{currentQuestionObject?.queType} </div>
            <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{ setHideSectionPopUp(true)}}  style={{display:"flex",justifyContent:"left",margin:"4px"}}  ><Plus
        onClick={()=>{ setHideSectionPopUp(true);}} 
         onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"5px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
 <div className="hidexs" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"5px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer",}}>  {findSectionNameByQuestionId(currentQuestionObject?.ID)?findSectionNameByQuestionId(currentQuestionObject?.ID):"Add Section"}</div> </div>
  <div onClick={()=>{ setCloseTopicSidebar(true)}} align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave}  style={{display:"flex",position:"relative",justifyContent:"left",marginTop:"5px",borderRadius:"5px",padding:"3px",right:"15px",border:"3px solid  rgba(144, 202, 249,1)"
           }}  ><Plus  onClick={()=>{ setCloseTopicSidebar(true)}} 
        strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" />
 <div  className="hidexs" style={{padding:"0px",background:"#fff",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer",}}> Link To Topic</div> </div>
</div>
         
         
        
            <div  className="questionsRightDashboardCardWithSection" style={{margin:"10px",marginTop:"5px",padding:"0px",paddingLeft:"0px",background:"transparent"}}>
<div className="courseContentItemJustifyContentIcons"><div><Pencil
        onClick={()=>{ setCreateNewQuestionPopUp(true);}} 
         onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"5px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/></div>
 </div><div className=""> <div className=""
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
 
   
  
   {currentQuestionObject?.queName}
   {/* <QuestionRichContent  postParentId={currentQuestionObject?.ID}/> */}
 
      </div></div><div className="courseContentItemJustifyContentIcons"><div
       onClick={()=>{ setExplanationPopUp(true);}}   onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave}  style={{display:"flex",justifyContent:"left",fontSize:"14px",gap:"10px"}}><Plus
        onClick={()=>{ setExplanationPopUp(true);}} 
        strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"5px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/> <div style={{cursor:"pointer",padding:"5px",width:"110px"}}>Add Explanation</div> </div>
 </div><div>
   
           {hideSectionPopUp?<SetSectionForQuestion questionId={currentQuestionObject?.ID} setHideSectionPopUp={()=>{setHideSectionPopUp(false);}}  parentID={quizObject?.postParent} quizObject={quizObject} 
         sendBackData={(sectionData)=>{setSectionsArr(sectionData);}} />:""}

            </div>

      </div></div>
            {closeTopicSidebar?<SetTopicSidebar currentIndex={currentIndex}  itemQuestion={currentQuestionObject} quizObject={quizObject} setCloseTopicSidebar={()=>{setCloseTopicSidebar(false)}} />:""}
            {showQuestionOptions&&<QuestionOptions questionObject={currentQuestionObject} questionType={currentQuestionObject?.queType} />}
 </div> 
        <div className="questionDashboardScroll" style={{overflowX:"hidden"}}>

 <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                {currentQuestionObject?.queType}  Question Configuration</div> 
                


   <div style={{background:"#ffffff",margin:"5px",display:"grid", gridTemplateColumns: "40% 60%" ,borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
                    <div style={{fontSize:"16px",fontWeight:"bold",paddingLeft:"10",padding:"8px",paddingTop:"15px"}}>
                        Marks  (+)</div>         
               <div style={{margin: '5px' ,paddingLeft:"20px",width:"150px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{setMarks(parseFloat(marks)>1?parseFloat(marks)-1:1)
 ;handleCreateNewQuestion("marks",parseFloat(marks)>1?parseFloat(marks)-1:1,currentQuestionObject?.ID?currentQuestionObject?.ID:""); 
  }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
    <input onMouseEnter={handleMouseEnter} 
     onMouseLeave={handleMouseLeave}  value={marks?parseFloat(marks):parseFloat(currentQuestionObject.marks)} type="number"
          onChange={(e)=>{
            ;handleCreateNewQuestion("marks",parseFloat(e.target.value)<100?parseFloat(e.target.value):1,currentQuestionObject?.ID?currentQuestionObject?.ID:""); 
            ;setMarks(parseFloat(e.target.value)<100?parseFloat(e.target.value):1);}}
          style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",marginLeft:"-5px",
            padding:"0px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
      />  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{setMarks(parseFloat(marks)<100?parseFloat(marks)+0.5:1)
      
        ;handleCreateNewQuestion("marks",parseFloat(marks)<100?parseFloat(marks)+0.5:1,currentQuestionObject?.ID?currentQuestionObject?.ID:""); 
      
      }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",
        alignContent:"center",textAlign:"center",marginLeft:"-5px",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
        
        
        
        </div> 
        
       
        
        </div>
<div class="input-card-outer" style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
               
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                             <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                           + 1
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={marks?parseFloat(marks)=="1":parseFloat(currentQuestionObject?.marks)=="1"?"yes":""}
                   className="input-textbox"  value={"1"}  name="marks1"  
                   onClick={e=>{setMarks("1")
      
        ;handleCreateNewQuestion("marks","1",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>             <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                           + 1.5
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={marks?parseFloat(marks)=="1.5":parseFloat(currentQuestionObject?.marks)=="1.5"?"yes":""}
                   className="input-textbox"  value={"1.5"}  name="marks1"  
                   onClick={e=>{setMarks("1.5")
      
        ;handleCreateNewQuestion("marks","1.5",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>   <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                            +2
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={marks?parseFloat(marks)=="2":parseFloat(currentQuestionObject?.marks)=="2"?"yes":""}
                   className="input-textbox"  value={"2"}  name="marks1"  
                   onClick={e=>{setMarks("2")
      
        ;handleCreateNewQuestion("marks","2",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>          
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                           + 2.5
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={marks?parseFloat(marks)=="2.5":parseFloat(currentQuestionObject?.marks)=="2.5"?"yes":""}
                   className="input-textbox"  value={"2.5"}  name="marks1"  
                   onClick={e=>{setMarks("2.5")
      
        ;handleCreateNewQuestion("marks","2.5",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                           + 5
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={marks?parseFloat(marks)=="5":parseFloat(currentQuestionObject?.marks)=="5"?"yes":""}
                   className="input-textbox"  value={"5"}  name="marks1"  
                   onClick={e=>{setMarks("5")
      
        ;handleCreateNewQuestion("marks","5",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>

                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                           + 10
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={marks?parseFloat(marks)=="10":parseFloat(currentQuestionObject?.marks)=="10"?"yes":""}
                   className="input-textbox"  value={"10"}  name="marks1"  
                   onClick={e=>{setMarks("10")
      
        ;handleCreateNewQuestion("marks","10",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        </div>  </div>





   <div style={{background:"#ffffff",margin:"5px",display:"grid", gridTemplateColumns: "40% 60%" ,borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
                    <div style={{fontSize:"16px",fontWeight:"bold",paddingLeft:"10px",padding:"8px",paddingTop:"15px"}}>
                        Negative Marks (-)</div>         
               <div style={{margin: '5px' ,paddingLeft:"20px",width:"150px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{setNegativeMarks(parseFloat(negativeMarks)>0?parseFloat(negativeMarks)-0.25:0)
 ;handleCreateNewQuestion("negativeMarks",parseFloat(negativeMarks)>0?parseFloat(negativeMarks)-0.25:0,currentQuestionObject?.ID?currentQuestionObject?.ID:""); 
  }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
    <input onMouseEnter={handleMouseEnter} cols={1} rows={1} 
     onMouseLeave={handleMouseLeave}  value={negativeMarks?parseFloat(negativeMarks):parseFloat(currentQuestionObject.negativeMarks)} type="number"
          onChange={(e)=>{
            ;handleCreateNewQuestion("negativeMarks",parseFloat(e.target.value)<100?parseFloat(e.target.value):0,currentQuestionObject?.ID?currentQuestionObject?.ID:""); 
            ;setNegativeMarks(parseFloat(e.target.value)<100?parseFloat(e.target.value):0);}}
          style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",marginLeft:"-5px",
            padding:"0px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
      />  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{setNegativeMarks(parseFloat(negativeMarks)<100?parseFloat(negativeMarks)+0.25:0)
      
        ;handleCreateNewQuestion("negativeMarks",parseFloat(negativeMarks)<100?parseFloat(negativeMarks)+0.25:0,currentQuestionObject?.ID?currentQuestionObject?.ID:""); 
      
      }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",
        alignContent:"center",textAlign:"center",marginLeft:"-5px",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
        
        
        
        </div> 
        
       
        
        </div>
         <div class="input-card-outer" style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
               
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                         <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             -1
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={negativeMarks?parseFloat(negativeMarks)=="1":parseFloat(currentQuestionObject?.negativeMarks)=="1"?"yes":""}
                   className="input-textbox"  value={"1"}  name="negativeMarks1"  
                   onClick={e=>{setNegativeMarks("1")
      
        ;handleCreateNewQuestion("negativeMarks","1",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             -0.67
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={negativeMarks?parseFloat(negativeMarks)=="0.67":parseFloat(currentQuestionObject?.negativeMarks)=="0.67"?"yes":""}
                   className="input-textbox"  value={"0.67"}  name="negativeMarks1"  
                   onClick={e=>{setNegativeMarks("0.67")
      
        ;handleCreateNewQuestion("negativeMarks","0.67",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             -0.5
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={negativeMarks?parseFloat(negativeMarks)=="0.5":parseFloat(currentQuestionObject?.negativeMarks)=="0.5"?"yes":""}
                   className="input-textbox"  value={"0.5"}  name="negativeMarks1"  
                   onClick={e=>{setNegativeMarks("0.5")
      
        ;handleCreateNewQuestion("negativeMarks","0.5",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             -0.33
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={negativeMarks?parseFloat(negativeMarks)=="0.33":parseFloat(currentQuestionObject?.negativeMarks)=="0.33"?"yes":""}
                   className="input-textbox"  value={"0.33"}  name="negativeMarks1"  
                   onClick={e=>{setNegativeMarks("0.33")
      
        ;handleCreateNewQuestion("negativeMarks","0.33",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                            - 0.25
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={negativeMarks?parseFloat(negativeMarks)=="0.25":parseFloat(currentQuestionObject?.negativeMarks)=="0.25"?"yes":""}
                   className="input-textbox"  value={"0.25"}  name="negativeMarks1"  
                   onClick={e=>{setNegativeMarks("0.25")
      
        ;handleCreateNewQuestion("negativeMarks","0.25",currentQuestionObject?.ID?currentQuestionObject?.ID:"")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        </div>  </div>


 <div style={{background:"#ffffff",margin:"5px",borderRadius:"15px",paddingBottom:"10px",marginTop:"10px",padding:"10px",}}>
                        

             <div className="" style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"10px",paddingBottom:"0px",marginTop:"10px",
              height:"80px"}}> 
       <div >  
           <div style={{}}> 
            <div class=""style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div style={{display:"flex",justifyContent:"space-between"}}>
                                          <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"10px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Difficulty</div>    <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column",}} >
                                              <div style={{display:"flex",justifyContent:"center"}}>
                                             <Baby onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                    <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Easy</div>
                                                                     </div>  
                                <input type="radio" title="Set As Years"   checked={difficultyLevel?difficultyLevel=="Easy":currentQuestionObject?.difficultyLevel=="Easy"?"yes":""}
                   className="input-textbox"  value={"Easy"}  name="difficultyLevel1"  
                   onClick={e=>{setDifficultyLevel("Easy");handleCreateNewQuestion("difficultyLevel","Easy",currentQuestionObject?.ID?currentQuestionObject?.ID:"");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column"}} >
                                              
                                             <div style={{display:"flex",justifyContent:"center"}}>
                                             <Cat onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                   <div style={{position:"relative",fontSize:"14px"}}>Medium</div>
                                                                    </div>  
                              <input type="radio" title="Set As Years"   checked={difficultyLevel?difficultyLevel=="Medium":currentQuestionObject?.difficultyLevel=="Medium"?"yes":""}
                   className="input-textbox"  value={"Medium"}  name="difficultyLevel1"  
                   onClick={e=>{setDifficultyLevel("Medium");handleCreateNewQuestion("difficultyLevel","Medium",currentQuestionObject?.ID?currentQuestionObject?.ID:"");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}} >
                                            <div style={{display:"flex",flexDirection:"column"}} >
                                            
                                           <div style={{display:"flex",justifyContent:"center"}}>
                                             <Rocket onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>                     
                                                                           <div style={{position:"relative",fontSize:"14px"}}>Difficult</div>
                                             </div> 
                                <input type="radio" title="Set As Years"   checked={difficultyLevel?difficultyLevel=="Difficult":currentQuestionObject?.difficultyLevel=="Difficult"?"yes":""}
                   className="input-textbox"  value={"Difficult"}  name="difficultyLevel1"  
                   onClick={e=>{setDifficultyLevel("Difficult");handleCreateNewQuestion("difficultyLevel","Difficult",currentQuestionObject?.ID?currentQuestionObject?.ID:"");}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div></div> </div>
                        
                                                    </div>

                 </div>

 <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Display Settings</div> 
      <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",margin:"10px",padding:"0px",overflow:"hidden"}}>

  <div  style={{background:"rgba(144, 202, 249,0.11)",margin:"5px",borderRadius:"15px",marginTop:"10px",padding:"5px",height:"60px"}}> 
  
                 
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}><div style={{textAlign:"left"}}><h4>{" Enable Display Marks"} </h4></div>
            <Toggle state={enableDisplayMarks==true?enableDisplayMarks:toBoolean(currentQuestionObject?.enableDisplayMarks)} toggleState={(state)=>{setEnableDisplayMarks(state); ;handleCreateNewQuestion("enableDisplayMarks",state,currentQuestionObject?.ID?currentQuestionObject?.ID:"");; ;}} />
    </div> </div></div>
  <div style={{background:"#ffffff",margin:"5px",borderRadius:"15px",paddingBottom:"10px",marginTop:"10px",padding:"10px",}}>
               
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}><div style={{textAlign:"left"}}><h4>{" User Response Speed"} </h4></div>         
  {responseTime?<RangeSliderBasic  rangeIntervalType="textMargin" rangeStart={0} rangeEnd={50}  pxPerType={"Sec"} setSliderVal={(val)=>{ setResponseTime(val);;handleCreateNewQuestion("responseTime",val,currentQuestionObject?.ID?currentQuestionObject?.ID:"");}} 
                 sliderVal={parseInt(currentQuestionObject?.responseTime)} />:""}
                  </div>  </div> 
 <div style={{background:"#ffffff",margin:"5px",borderRadius:"15px",paddingBottom:"10px",marginTop:"10px",padding:"10px",}}>
                        

             <div className="" style={{background:"rgba(144, 202, 249,0.11)",borderRadius:"10px",paddingBottom:"0px",marginTop:"10px",
              height:"80px"}}> 
       <div >  
           <div style={{}}> 
            <div class=""style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"5px"}} >
                                          
                                          <div style={{display:"flex",justifyContent:"space-between"}}>
                                          <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"10px",
                 paddingLeft:"10px",display:"flex",justifyContent:"left"}}>
                  Divide Column Display</div>    <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column",}} >
                                              <div style={{display:"flex",justifyContent:"center"}}>
                                             <SquareSplitHorizontal onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                    <div style={{position:"relative",fontSize:"14px",textAlign:"center"}}>Yes</div>
                                                                     </div>  
                                <input type="radio" title="Set As Years"   checked={divideColumn?divideColumn=="true":currentQuestionObject?.divideColumn=="true"?"yes":""}
                   className="input-textbox"  value={"true"}  name="divideColumn1"  
                   onClick={e=>{setDivideColumn("true");handleCreateNewQuestion("divideColumn","true",currentQuestionObject?.ID?currentQuestionObject?.ID:"");}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column"}} >
                                              
                                             <div style={{display:"flex",justifyContent:"center"}}>
                                             <RectangleHorizontal onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                   <div style={{position:"relative",fontSize:"14px"}}>No</div>
                                                                    </div>  
                                <input type="radio" title="Set As Years"   checked={divideColumn?divideColumn=="false":currentQuestionObject?.divideColumn=="false"?"yes":""}
                   className="input-textbox"  value={"false"}  name="divideColumn1"  
                   onClick={e=>{setDivideColumn("false");handleCreateNewQuestion("divideColumn","false",currentQuestionObject?.ID?currentQuestionObject?.ID:"");}}/>
                                        <span class={"boxCardBorder-two"}></span> </label>
                      
                        </div>  </div></div> </div>
                        
                                                    </div>

                 </div>
                 <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",margin:"10px",padding:"0px",overflow:"hidden"}}>

  <div  style={{background:"rgba(144, 202, 249,0.11)",margin:"5px",borderRadius:"15px",marginTop:"10px",padding:"5px",height:"60px"}}> 
  
                         <div style={{background:"transparent",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-around"
            }}><div style={{textAlign:"left"}}><h4>{" Enable Question Hint"} </h4></div>
            <Toggle state={enableQueHint==true?enableQueHint:toBoolean(currentQuestionObject?.enableQueHint)} toggleState={(state)=>{setEnableQueHint(state); ;handleCreateNewQuestion("enableQueHint",state,currentQuestionObject?.ID?currentQuestionObject?.ID:"");; ;}} />
   </div> </div>
    {enableQueHint==true||(currentQuestionObject?.enableQueHint)?<div style={{paddingTop:"10px",position:"relative"}}>
{/*   
   <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             <Plus onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                     
                                             </div> 
                              <input type="checkbox" title="show Hint PopUp"   checked={showHintPopUp?"yes":""}
                   className="input-textbox"  value={showHintPopUp}  name="showHintPopUp1"  
                   onChange={e=>{setShowHintPupUp(e.target.checked);}}/>
                        <span class={"boxCardBorder-two"}></span> </label> */}
{reloadItems?
               <div  className="ikcraft_login-input-card">
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Quiz Name`} type="text"
  rows={4} name="courseTitle" value={hintInfo!==""?hintInfo:(currentQuestionObject?.hintInfo)} onChange={(e)=>{setHintInfo(e.target.value);;handleCreateNewQuestion("hintInfo",e.target.value,currentQuestionObject?.ID?currentQuestionObject?.ID:"");}} />
 </div>:""}</div> :""}
                      </div>
               
                                  
       </div>
       
       
       </div>
       </div>

        </div> 
        
        
         </div>  </div> 

     {showTestPreview?<MockTest quizObject={quizObject} setShowTestPreview={()=>{setShowTestPreview(false)}}/>:""}
  
      
                                    
     </>)  
   }
   export default QuestionDashboard;